import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { ISetting } from '@/shared/model/setting.model';

const baseApiUrl = 'api/settings';
const baseSearchApiUrl = 'api/_search/settings?query=';

export default class SettingService {
  public getUserInfoGroups(userId: number): Promise<string[]> {
    return new Promise<string[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/application-user/${userId}/info-groups`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public setUserInfoGroup(userId: number, groupName: string, value: boolean): Promise<string[]> {
    return new Promise<string[]>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/application-user/${userId}/info-groups/${encodeURIComponent(groupName)}?value=${value}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public find(id: number): Promise<ISetting> {
    return new Promise<ISetting>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getBaseUrl(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/base-url`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveForAgency(agencyId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/agency/${agencyId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ISetting): Promise<ISetting> {
    return new Promise<ISetting>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public saveMultiple(entity: ISetting[]): Promise<ISetting[]> {
    return new Promise<ISetting[]>((resolve, reject) => {
      axios
        .post(`api/multiple-settings`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ISetting): Promise<ISetting> {
    return new Promise<ISetting>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: ISetting): Promise<ISetting> {
    return new Promise<ISetting>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
